import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

import { deleteSpacerMenuItem } from '../menu-item/delete-spacer-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';
import { lockPositionMenuItem } from '../menu-item/lock-position-menu-item';
import { spacerPropertiesMenuItem } from '../menu-item/spacer-properties-menu-item';

export const spacerMenuList: Array<ContextMenuList> = [
	deleteSpacerMenuItem(),
	lockPositionMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	spacerPropertiesMenuItem(),
	islandPropertiesMenuItem()
];
